import { FC } from 'react';

import { CapturePiece, CurrentSessionProps, DrawerTypes, IdV4, Steps } from '../../../../types';
import NotSelectedView from './NotSelected';
import Piece from './Piece';

type Props = {
  handleBack: () => void;
  capturePiece: CapturePiece;
  setDrawer: (type: DrawerTypes) => void;
  onCropClick: (returnPath: Steps) => void;
  retryFailedPieces: (id: IdV4) => void;
  currentSession: CurrentSessionProps;
  onDeletePiece: () => void;
};

const PieceView: FC<Props> = ({ capturePiece, ...rest }) =>
  capturePiece ? <Piece capturePiece={capturePiece} {...rest} /> : <NotSelectedView />;

export default PieceView;
